// Nombres legibles de los facets del índice de productos (los mismos campos en
// Algolia y en Typesense) y de sus valores. Los att_* ya se leen bien sin el
// prefijo.
const FACET_TITLES = {
  brand: "Part brand",
  brand_vehicle: "Vehicle brand",
  product_type: "Unit",
  engines: "Engine",
  dependencia: "Dependencia",
  "price_and_stock.available": "Availability · any store",
  "price_and_stock.is_offer": "On offer"
};

export const ANY_STORE_AVAILABILITY = "price_and_stock.available";
export const OFFER = "price_and_stock.is_offer";

// price_and_stock_by_store.MIA.available -> MIA
const STORE_AVAILABILITY = /^price_and_stock_by_store\.(.+)\.available$/;

export const availabilityStore = type => {
  const store = STORE_AVAILABILITY.exec(type);
  return store ? store[1] : null;
};

export const isAvailabilityFacet = type =>
  type === ANY_STORE_AVAILABILITY || STORE_AVAILABILITY.test(type);

const AVAILABILITY_VALUES = {
  "in stock": "In stock",
  "out of stock": "Out of stock",
  backorder: "Backorder",
  incoming: "Incoming",
  catalog: "Catalog"
};

// Qué significa cada letra de dependencia: se muestra debajo de la opción.
const DEPENDENCIA_HINTS = {
  A: "Solo stock disponible",
  B: "Stock + dropship",
  B2: "Catálogo/dropship (vendible)",
  E: "Solo stock disponible",
  M: "Solo stock disponible",
  V: "Stock + dropship",
  X: "Solo stock disponible",
  Z: "Catálogo display (no vendible)"
};

export const facetTitle = type => {
  const store = availabilityStore(type);
  if (store) return `Availability · ${store}`;
  return FACET_TITLES[type] || type.split("att_").pop();
};

// Cómo se ve un valor; el que se filtra sigue siendo el original. Algunos
// atributos llegan con espacios delante ("  Front Left").
export const facetValueLabel = (type, value) => {
  const text = String(value).trim();
  if (isAvailabilityFacet(type)) {
    return AVAILABILITY_VALUES[text.toLowerCase()] || text;
  }
  if (type === OFFER) {
    return text === "1" ? "Yes" : text === "0" ? "No" : text;
  }
  if (type === "engines") {
    // "4HK1 - 5.2" -> "4HK1 5.2L"
    const [engine, liter] = text.split(" - ");
    return liter ? `${engine} ${liter}L` : text;
  }
  return text;
};

export const facetValueHint = (type, value) =>
  type === "dependencia" ? DEPENDENCIA_HINTS[String(value).trim()] : null;

// Orden alfabético (el buscador da las opciones por cantidad), con los números
// en su orden ("2" antes que "10") y sin distinguir mayúsculas.
export const byLabel = (a, b) =>
  a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });

export const formatCount = count => Number(count || 0).toLocaleString("en-US");
